import { AuthResponse, MccsRoles } from '@/@types/generated'
import { Feature } from './feature'
import { hasFeature, hasRole } from '@/components/Atoms/Permissions'
import { AutonomousVehiclesFeature } from './autonomous-vehicles'
import { ApplicationRoles, InternalRoles } from '../utils'

export const CompaniesFeature = {
  // Roles that are eligible for the Companies feature
  Roles: [...InternalRoles, ...ApplicationRoles],

  // Determine if the feature is enabled for the given user
  isEnabled: (user: AuthResponse | null): boolean =>
    hasRole(CompaniesFeature.Roles, user),

  // ---------------------------------
  // Sub-features
  // ---------------------------------

  // Edit Company Details
  EditDetails: {
    isEnabled: (user: AuthResponse | null): boolean =>
      hasRole(
        [
          // Credentialing users
          MccsRoles.CREDENTIALING_ADMIN,
          MccsRoles.CREDENTIALING,
          // ...or owner
          MccsRoles.AUTONOMOUS_VEHICLE_OWNER,
          MccsRoles.MOTOR_CARRIER_OWNER,
        ],
        user
      ),
  } satisfies Feature,

  // Automated Vehicles
  AutomatedVehicles: {
    isEnabled: (user: AuthResponse | null): boolean =>
      // Internal user
      hasRole(InternalRoles, user) ||
      // ...or has AV feature
      hasFeature(AutonomousVehiclesFeature, user),
  } satisfies Feature,

  // Users
  Users: {
    isEnabled: (user: AuthResponse | null): boolean =>
      hasRole(
        [
          // Credentialing access
          MccsRoles.CREDENTIALING,
          MccsRoles.CREDENTIALING_ADMIN,
          // ...or owner
          MccsRoles.AUTONOMOUS_VEHICLE_OWNER,
          MccsRoles.MOTOR_CARRIER_OWNER,
        ],
        user
      ),
  } satisfies Feature,

  // Company history can be viewed
  History: {
    isEnabled: (user: AuthResponse | null): boolean =>
      // Internal user
      hasRole(InternalRoles, user) ||
      // ...or owner
      hasRole(
        [MccsRoles.AUTONOMOUS_VEHICLE_OWNER, MccsRoles.MOTOR_CARRIER_OWNER],
        user
      ),
  } satisfies Feature,

  // VIN Lookup
  VinLookup: {
    isEnabled: (user: AuthResponse | null): boolean =>
      hasRole(
        [
          // Internal user
          ...InternalRoles,
          // ...or insurance user
          MccsRoles.INSURANCE_PROVIDER,
        ],
        user
      ),
  } satisfies Feature,
} satisfies Feature
